import { render, staticRenderFns } from "./CustomerExcelTemplate.vue?vue&type=template&id=2bb40410&scoped=true"
import script from "./CustomerExcelTemplate.vue?vue&type=script&lang=js"
export * from "./CustomerExcelTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb40410",
  null
  
)

export default component.exports